// Icon imports
// Import icons from unplugin-icons
// Format: ~icons/{collection}/{icon-name}?raw (raw SVG string)

// Example: Material Design Icons
// import IconMenuRaw from '~icons/mdi/menu?raw'
// import IconCloseRaw from '~icons/mdi/close?raw'
// import IconHomeRaw from '~icons/mdi/home?raw'
// import IconPhoneRaw from '~icons/mdi/phone?raw'
// import IconEmailRaw from '~icons/mdi/email?raw'
// import IconArrowRightRaw from '~icons/mdi/arrow-right?raw'
// import IconChevronDownRaw from '~icons/mdi/chevron-down?raw'

// // Example: Heroicons
// import IconSearchRaw from '~icons/heroicons/magnifying-glass-20-solid?raw'
// import IconUserRaw from '~icons/heroicons/user-20-solid?raw'

// // Example: Carbon icons
// import IconBuildingRaw from '~icons/carbon/building?raw'
// import IconLocationRaw from '~icons/carbon/location?raw'

import MdiChevronDown from "~icons/mdi/chevron-down?raw";
import MdiArrowRight from "~icons/mdi/arrow-right?raw";
import MdiLinkedin from "~icons/mdi/linkedin?raw";
import MdiInstagram from "~icons/mdi/instagram?raw";
import MdiFacebook from "~icons/mdi/facebook?raw";

// Export as an object that can be accessed by icon name
export const icons = {
  IconChevronDown: MdiChevronDown,
  IconArrowRight: MdiArrowRight,
  IconLinkedIn: MdiLinkedin,
  IconInstagram: MdiInstagram,
  IconFacebook: MdiFacebook,
};

/**
 * Helper function to inject classes into an SVG string
 * Also removes default width/height attributes to allow CSS control
 * @param {string} svgString - The raw SVG string
 * @param {string} classNames - Space-separated class names to add
 * @returns {string} Modified SVG string with classes injected
 */
export function injectSvgClasses(svgString, classNames = "") {
  if (!svgString) return "";

  // Remove width and height attributes, add/merge class attribute
  let modifiedSvg = svgString
    .replace(/width="[^"]*"/g, "")
    .replace(/height="[^"]*"/g, "");

  // Check if SVG already has a class attribute
  if (modifiedSvg.includes('class="')) {
    // Append to existing class
    modifiedSvg = modifiedSvg.replace(
      /class="([^"]*)"/,
      `class="$1 ${classNames}"`,
    );
  } else {
    // Add new class attribute after <svg
    modifiedSvg = modifiedSvg.replace(/<svg/, `<svg class="${classNames}"`);
  }

  return modifiedSvg;
}

// You can add more icons as needed from any collection
// Browse icons at: https://icones.js.org/
